import React, { Fragment, Component } from "react";
import Breadcrumb from "../../components/common/breadcrumb";
import BrandForm from "./components/form";
import BrandTable from "./components/table";
import InvoiceService from "../../services/invoiceService";
import { apiURL } from "../../utlis/config";
import $ from "jquery";
// import store from "store";

class CreateBrand extends Component {
  state = {
    infoData: {
      subtotal: (0).toFixed(2),
      total: (0).toFixed(2),
      balanceDue: (0).toFixed(2),
      tax: 0,
      discount: 0,
      shipping: 0,
      amountPaid: 0,
      balanceDue: 0,
    },
    subtotal: (0).toFixed(2),
    infoInvoiceItems: [
      { item: "", quantity: 1, rate: 0, amount: (0).toFixed(2) },
    ],
  };

  componentWillMount() {
    this.callApiInfo();
  }
  callApiInfo = () => {
    const { infoData } = this.state;
    InvoiceService.fetchInvoiceNumber().then((response) => {
      if (!response.error) {
        infoData["invoiceNumber"] = response.data.invoice;
        this.setState({
          infoData,
        });
      }
    });
    this.setState({ loader: false });
  };
  addBrandForm = (data) => {
    const { isEdit, info, imageUrl, infoData, infoInvoiceItems } = this.state;
    this.setState({ loader: true });

    data["imageUrl"] = imageUrl;
    data["amountPaid"] = infoData.amountPaid;
    data["balanceDue"] = infoData.balanceDue;
    data["discount"] = infoData.discount;
    data["shipping"] = infoData.shipping;
    data["subtotal"] = infoData.subtotal;
    data["tax"] = infoData.tax;
    data["total"] = infoData.total;
    data["infoInvoiceItems"] = infoInvoiceItems;
    var method = isEdit ? "PUT" : "POST";
    console.log({ data });
    InvoiceService.addInvoice(data, method).then((response) => {
      if (!response.error) {
        window.open(apiURL + response.data, "_blank");
        this.props.history.push("/invoices/all");
      }
      this.setState({ loader: false });
    });
  };
  onClickToggle = () => {
    this.setState({ modalFormShow: false });
  };
  onChangeImage = (imageUrl) => {
    this.setState({ imageUrl: imageUrl });
  };

  removeImage = () => {
    this.setState({ imageUrl: undefined });
  };

  onChangeUrl = (name, url) => {
    if (
      (name && name !== "") ||
      (url && url !== "undefined") ||
      (url === "" && url !== "undefined")
    ) {
      var { infoData, urlEdit } = this.state;
      var stringUrl = "";
      var urlEdit1 = false;
      if (name && !urlEdit) {
        stringUrl = name.toLowerCase();
        urlEdit1 = urlEdit || urlEdit1;
      } else if (url && url !== "undefined") {
        stringUrl = url.toLowerCase();
        urlEdit1 = true;
      } else if (url === "" && url !== "undefined") {
        stringUrl = url;
        urlEdit1 = false;
      } else {
        stringUrl = infoData["sUrl"] || "";
        urlEdit1 = urlEdit || urlEdit1;
      }
      stringUrl = stringUrl.replace(/ /g, "_");
      stringUrl = stringUrl.replace(/,/g, "_");
      stringUrl = stringUrl.replace(/__/g, "_");
      if (infoData) {
        infoData["sUrl"] = stringUrl;
      } else {
        infoData = { sUrl: stringUrl };
      }
      this.setState({ infoData: infoData, urlEdit: urlEdit1 });
    }
  };

  addLineItem = () => {
    const { infoInvoiceItems } = this.state;
    infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
    this.setState({ infoInvoiceItems });
  };
  grantTotal = () => {
    var { infoData } = this.state;
    var {
      tax,
      discount,
      shipping,
      subtotal,
      total,
      amountPaid,
      balanceDue,
    } = infoData;
    console.log({ infoData });
    subtotal = parseFloat(subtotal);
    console.log({ subtotal });
    console.log({ tax });
    var taxAmount =
      tax && tax !== 0 && tax !== "0"
        ? subtotal + subtotal * (Number(tax) / 100)
        : subtotal;
    //  var numVal1 = Number(document.getElementById("price").value);
    //  var numVal2 = Number(document.getElementById("discount").value) / 100;

    //  var totalValue = numVal1 - numVal1 * numVal2;
    //  document.getElementById("total").value = totalValue.toFixed(2);
    console.log({ taxAmount }, (subtotal * 100) % parseInt(tax));
    var discountAmount =
      discount && discount !== 0 && discount !== "0"
        ? taxAmount - taxAmount * (Number(discount) / 100)
        : taxAmount;
    console.log({ discountAmount });
    var shippingAmount =
      shipping && shipping !== 0 && shipping !== "0"
        ? discountAmount + parseFloat(shipping)
        : discountAmount;
    console.log({ shippingAmount });
    total = shippingAmount;
    console.log({ total });
    balanceDue =
      amountPaid && amountPaid !== 0 && amountPaid !== "0"
        ? total - parseFloat(amountPaid)
        : total;
    console.log({ balanceDue });
    infoData["total"] = total.toFixed(2);
    infoData["balanceDue"] = balanceDue.toFixed(2);
    this.setState({
      infoData,
      total: total.toFixed(2),
      balanceDue: balanceDue.toFixed(2),
    });
  };
  render() {
    const {
      brandId,
      infoData,
      modalFormShow,
      loader,
      info,
      index,
      isEdit,
      imageUrl,
      subtotal,
    } = this.state;
    const {
      loading,
      page,
      pageSize,
      totalRecords,
      infoInvoiceItems,
    } = this.state;
    const itemInfoProps = {
      onChangeItem: (item, index) => {
        const { infoInvoiceItems, infoData } = this.state;
        infoInvoiceItems[index]["item"] = item;
        // var subtotal = infoInvoiceItems
        //   .map((invoice) => invoice.amount) // get the age values
        //   .reduce((sum, current) => sum + current); // sum the age values
        // infoData["subtotal"] = subtotal;
        // console.log(subtotal);
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        this.setState({ infoInvoiceItems });
      },
      onChangeQuantity: (quantity, index) => {
        const { infoInvoiceItems, infoData } = this.state;
        infoInvoiceItems[index]["quantity"] = quantity;
        infoInvoiceItems[index]["amount"] = (
          quantity * infoInvoiceItems[index]["rate"]
        ).toFixed(2);
        console.log({ quantity }, infoInvoiceItems[index]);
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        var subtotal = infoInvoiceItems
          .map((invoice) => parseFloat(invoice.amount)) // get the age values
          .reduce((sum, current) => sum + current); // sum the age values

        infoData["subtotal"] = subtotal.toFixed(2);
        console.log({ subtotal, infoData });
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        this.setState({ infoInvoiceItems, infoData }, function () {
          this.grantTotal();
        });
      },
      onChangeRate: (rate, index) => {
        const { infoInvoiceItems, infoData } = this.state;
        infoInvoiceItems[index]["rate"] = rate;
        infoInvoiceItems[index]["amount"] = (
          rate * infoInvoiceItems[index]["quantity"]
        ).toFixed(2);
        console.log({ rate }, infoInvoiceItems[index]);
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        var subtotal = infoInvoiceItems
          .map((invoice) => parseFloat(invoice.amount)) // get the age values
          .reduce((sum, current) => sum + current); // sum the age values

        infoData["subtotal"] = subtotal.toFixed(2);
        infoData["subtotal"] = subtotal.toFixed(2);
        console.log({ subtotal, infoData });
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        this.setState({ infoInvoiceItems, infoData }, function () {
          this.grantTotal();
        });
      },

      mouseOver: (index) => {
        const { infoInvoiceItems } = this.state;
        if (infoInvoiceItems.length > 1)
          infoInvoiceItems[index]["isClose"] = true;
        // infoInvoiceItems.push({ item: "", quantity: 1, rate: 0, amount: 0 });
        this.setState({ infoInvoiceItems });
      },
      mouseOut: (index) => {
        const { infoInvoiceItems } = this.state;
        infoInvoiceItems[index]["isClose"] = false;
        this.setState({ infoInvoiceItems });
      },
      onClose: (index) => {
        const { infoInvoiceItems } = this.state;
        infoInvoiceItems.splice(index, 1);
        // infoInvoiceItems[index]["isClose"] = false;
        this.setState({ infoInvoiceItems });
      },
    };
    const brandFormProps = {
      onChangeAmountPaid: (amountPaid) => {
        console.log({ amountPaid });
        infoData["amountPaid"] = amountPaid; //.toFixed(2);
        this.setState({ infoData }, function () {
          this.grantTotal();
        });
      },
      onChangeDiscount: (discount) => {
        console.log({ discount });
        infoData["discount"] = discount;
        this.setState({ infoData }, function () {
          this.grantTotal();
        });
      },
      onChangeShipping: (shipping) => {
        console.log({ shipping });
        infoData["shipping"] = shipping;
        this.setState({ infoData }, function () {
          this.grantTotal();
        });
      },
      onChangeTax: (tax) => {
        console.log({ tax });
        infoData["tax"] = tax;
        this.setState({ infoData }, function () {
          this.grantTotal();
        });
      },
      subtotal: subtotal,
      info: infoData || {},
      active: this.state.active,
      imageUrl: imageUrl,
      onChangeImage: this.onChangeImage,
      removeImage: this.removeImage,
      onChangeUrl: this.onChangeUrl,
      searchProductUrl: "",
      searchUrlStatus: false,
      isEdit: this.state.isEdit,
      onChangeBrandId: (id) => {
        console.log({ id });
      },
      onClickConfirm: (data) => {
        //console.log(data)
        this.addBrandForm(data);
      },
      onClickActive: (active) => {
        this.setState({ active });
      },
      itemInfoProps,
      addLineItem: () => {
        this.addLineItem();
      },
      infoInvoiceItems,

      //  var endDate = moment(dateString[1]).format();
      onChangeBill: (billDate) => {
        infoData.billDate = billDate;
        this.setState({ infoData });
      },
      onChangeDueBill: (dueDate) => {
        infoData.dueDate = dueDate;
        this.setState({ infoData });
      },
      // BrandForm: infoData,
    };
    return (
      <Fragment>
        <Breadcrumb title={"Add"} parent="Invoice" />
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                {/* <div className="card-header">
                  <h5>Select Multiple Data</h5>
                </div> */}

                {loader && (
                  <div
                    style={{
                      position: "fixed",
                      top: "50%",
                      right: "45%",
                      zIndex: "+999",
                    }}
                  >
                    <div className="loader bg-white">
                      <div className="whirly-loader"> </div>
                    </div>
                  </div>
                )}

                <BrandForm {...brandFormProps} />
              </div>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

export default CreateBrand;
